module.exports = __webpack_public_path__ + "img/BKDell.da27b793.png";